import { h, Component } from 'preact'
import { translateOrEmpty, addTranslation, TranslationCategory, TranslationParameters } from './translations'
import localStorageCache from '../../utils/localStorageCache'
import axios from 'axios'
import TranslationsEdit from '../../preact-components/translations/index'

type PhraseCallback = (phrase?: string) => void

type PhraseCallbackSet = [TranslationCategory, string, PhraseCallback[]]

type Batch = PhraseCallbackSet[]

let batch: Batch = []
let batchRequest: number | undefined
let inFlightBatch = batch
let callbacksList: Array<() => void> = []

const makeRequest = () => {
  const currentBatch = batch
  batch = []
  inFlightBatch = batch
  axios
    .get('/phrase/batch', {
      params: {
        phrases: JSON.stringify(
          currentBatch.map(([module, phrase]) => [module, phrase])
        )
      }
    })
    .then(function ({ data }) {
      inFlightBatch = batch
      currentBatch.forEach(function ([module, phrase, cbList]) {
        let value
        try {
          value = data[module][phrase]
        } catch (error) {
          cbList.forEach(cb => cb())
          return
        }
        localStorageCache.setItem(`${module}|${phrase}`, value)
        addTranslation(module, phrase, value)
        cbList.forEach(cb => cb(translateOrEmpty(module, phrase, {})))
      })
      callbacksList.forEach(callback => callback())
      callbacksList = []
    })
}

export const fetchPhrase = (module: TranslationCategory, phrase: string, cb: PhraseCallback, batchCb?: () => void) => {
  const cachedPhrase = localStorageCache.getItem(`${module}|${phrase}`)
  if (typeof cachedPhrase === 'string') {
    cb(cachedPhrase)
  }
  const isAlreadyQueued = inFlightBatch.some(
    ([batchedModule, batchedPhrase, cbList]) => {
      if (module === batchedModule && batchedPhrase === phrase) {
        cbList.push(cb)
        return true
      }
      return false
    }
  )
  if (batchCb) callbacksList.push(batchCb)
  if (isAlreadyQueued) return
  batch.push([module, phrase, [cb]])
  clearTimeout(batchRequest)
  batchRequest = window.setTimeout(() => makeRequest(), 50)
}

interface Props {
  p: string
  m?: TranslationCategory
  count?: TranslationParameters
}

interface State {
  isAvailable: string | null
}

export default class Phrase extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.fetch(props)
  }

  componentWillReceiveProps () {
    this.fetch(this.props)
  }

  fetch ({ p = 'key', m = 'Forum', count = {} }: Props) {
    if (translateOrEmpty(m, p, count)) return
    fetchPhrase(m, p, () => {
      this.setState({ isAvailable: translateOrEmpty(m, p, count) })
    })
  }

  render ({ p = 'key', m = 'Forum', count = {} }: Props) {
    const phrase = translateOrEmpty(m, p, count)
    const isLiveEditing = phrase.match('::phrase::')
    if (!isLiveEditing) return phrase
    return (
      <TranslationsEdit
        translationString={translateOrEmpty(m, p, {})}
      />
    )
  }
}
